"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[164],{

/***/ 82164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30693);



var farms = [
    /**
     * These 3 farms (PID 0, 2, 3) should always be at the top of the file.
     */ {
        pid: 0,
        lpSymbol: "RUN",
        lpAddress: "0x9e3d30d7808C8E64dB360Abf2f32B44eB03F55d4",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .onusMainnetTokens.vndc */ .Au.vndc,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .onusMainnetTokens.runtogether */ .Au.runtogether
    },
    {
        pid: 1,
        lpSymbol: "RUN-VNDC LP",
        lpAddress: "0x6600E83aEd427895e5513aC79613e36E2E71198E",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .onusMainnetTokens.runtogether */ .Au.runtogether,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .onusMainnetTokens.vndc */ .Au.vndc,
        boosted: false
    }, 
].map(function(p) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, p), {
        token: p.token.serialize,
        quoteToken: p.quoteToken.serialize
    });
});
/* harmony default export */ __webpack_exports__["default"] = (farms);


/***/ })

}]);